import { groupSectionEntityName } from '../../../../../../backend/config/classifiers/GroupSectionClassifier/shared';
import { useContactManagementTranslation } from '../../../../../../ui/hooks/useContactManagementTranslation';
import { FormViewer } from '@juvare/common-form-ui/FormViewer';
import { callConfigFunction } from '@juvare/common-form-ui/WidgetForm/Utils';
import { showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import { useAnonymousStorageGet } from '@juvare/platform-sdk-react/ui/hooks';
import { Alert, Box, Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React from 'react';
import { useGroupSections } from '../../../hooks/useGroupSections';
export function showGroupDetailsDialog(params) {
    showCustomDialog({
        maxWidth: params.maxWidth,
        fullWidth: params.fullWidth,
        content: (close) => React.createElement(FormDialogContent, Object.assign({}, params, { close: close })),
    });
}
const FormDialogContent = (props) => {
    var _a;
    const { t } = useContactManagementTranslation();
    const detailsSection = (_a = useGroupSections()) === null || _a === void 0 ? void 0 : _a.find((s) => s.columns.key === 'details');
    const [showErrors, setShowErrors] = React.useState('changed');
    const [widgetData, setWidgetData] = React.useState();
    const initialData = React.useRef(props.initialData);
    const { data: sectionResponse, error: sectionError } = useAnonymousStorageGet(groupSectionEntityName, detailsSection === null || detailsSection === void 0 ? void 0 : detailsSection.id);
    const config = sectionResponse === null || sectionResponse === void 0 ? void 0 : sectionResponse.data.form;
    if (config &&
        config.children &&
        props.showGroupTypeWidgets &&
        !config.children.filter((config) => config.type === 'form.yesNo').length) {
        const filterBasedSelectionItems = [
            {
                type: 'form.yesNo',
                key: 'filterBased',
                label: 'Type Of Group',
                labels: {
                    noLabel: 'Selected Accounts',
                    yesLabel: 'Based On Filters',
                },
            },
            {
                type: 'form.content',
                text: 'By default, filter based groups include all accounts. You can review and adjust the list of accounts if needed.',
                style: {
                    alert: 'warning',
                },
                hidden: {
                    when: '^filterBased',
                    dataEq: false,
                },
            },
        ];
        config.children.push(...filterBasedSelectionItems);
    }
    if (!(sectionResponse === null || sectionResponse === void 0 ? void 0 : sectionResponse.data)) {
        if (sectionError) {
            return React.createElement(Alert, { color: 'error' }, t('panels.groups.failedToLoadSectionConfig'));
        }
        else {
            return null;
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogTitle, { "data-test": 'form-dialog-title' }, props.title),
        React.createElement(DialogContent, null,
            React.createElement(Box, { pt: 1 },
                React.createElement(FormViewer, { config: config, showErrors: showErrors, onDataChange: setWidgetData, data: config.onLoad
                        ? callConfigFunction(config.onLoad, 'form onLoad', 'data', initialData.current)
                        : initialData.current }))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { color: 'primary', onClick: () => props.close(), "data-test": 'form-dialog-cancel-button' }, t('common.cancel')),
            React.createElement(Button, { color: 'primary', onClick: () => {
                    setShowErrors('all');
                    if (widgetData === null || widgetData === void 0 ? void 0 : widgetData.valid) {
                        props.onSubmit(config.onSubmit
                            ? callConfigFunction(config.onSubmit, 'form onSubmit', 'data', widgetData === null || widgetData === void 0 ? void 0 : widgetData.data)
                            : widgetData === null || widgetData === void 0 ? void 0 : widgetData.data);
                        props.close();
                    }
                }, "data-test": 'form-dialog-submit-button' }, t('common.submit')))));
};
